<rt-dropdown [width]="DropdownWidth.FullWidth">
  <div class="content">
    <rt-form-field class="form-field">
      <rt-input
        (keyup.enter)="save.next()"
        [autoFocus]="true"
        [formControl]="formControl"
        [hasClearButton]="false"
        [placeholder]="'wysiwyg.paste_url_placeholder' | translate"
        variant="rounded"
      >
        <rt-icon prefix name="link" />
      </rt-input>
    </rt-form-field>
  </div>
</rt-dropdown>
